export default __webpack_public_path__ + "static/standard-terminal-a0da03e17036d2d32a32a22e88832004.jpg";